/* ==========================================================================
   ICEDCANDY - premium product page behaviour
   Builds the mobile sticky add-to-cart bar and keeps it in step with the
   selected variant. Everything else on the page is CSS or Dawn's own JS.
   ========================================================================== */
(function () {
  function priceText(root) {
    var el = root.querySelector('.price__container .price-item--sale, .price__container .price-item--regular');
    return el ? el.textContent.trim() : '';
  }

  function productName(root) {
    var heading = root.querySelector('.product__title h1, h1.product__title, .product__title h2');
    if (heading) return heading.textContent.trim();
    var wrap = root.querySelector('.product__title');
    return wrap ? wrap.textContent.trim().split('\n')[0].trim() : document.title;
  }

  function build(root) {
    var img = root.querySelector('.product__media img');
    var bar = document.createElement('div');

    bar.className = 'pp-sticky';
    bar.setAttribute('data-pp-sticky', '');
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');
    bar.innerHTML =
      '<span class="pp-sticky__media" data-pp-sticky-media>' +
      (img ? '<img alt="" src="' + (img.currentSrc || img.src) + '">' : '') +
      '</span>' +
      '<span class="pp-sticky__info">' +
      '<span class="pp-sticky__title" data-pp-sticky-title></span>' +
      '<span class="pp-sticky__price" data-pp-sticky-price></span>' +
      '</span>' +
      '<button type="button" class="pp-sticky__button" data-pp-sticky-add data-add-label="Add">Add</button>';

    var titleEl = bar.querySelector('[data-pp-sticky-title]');
    var name = productName(root);
    titleEl.dataset.baseTitle = name;
    titleEl.textContent = name;
    bar.querySelector('[data-pp-sticky-price]').textContent = priceText(root);

    document.body.appendChild(bar);
    return bar;
  }

  function init(root) {
    if (root.dataset.ppReady === 'true') return;
    var form = root.querySelector('.product-form__buttons');
    if (!form) return;
    root.dataset.ppReady = 'true';

    var bar = root.querySelector('[data-pp-sticky]') || build(root);
    var barButton = bar.querySelector('[data-pp-sticky-add]');
    var priceEl = bar.querySelector('[data-pp-sticky-price]');
    var titleEl = bar.querySelector('[data-pp-sticky-title]');
    var mediaEl = bar.querySelector('[data-pp-sticky-media] img');

    if (!titleEl.dataset.baseTitle) titleEl.dataset.baseTitle = productName(root);

    /* Show the bar only once the real button has scrolled past. */
    function reveal() {
      var rect = form.getBoundingClientRect();
      bar.classList.toggle('is-visible', rect.bottom < 0);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function () { reveal(); }, { threshold: 0 }).observe(form);
    }
    window.addEventListener('scroll', reveal, { passive: true });
    window.addEventListener('resize', reveal);
    reveal();

    /* The bar clicks the real button, so Dawn's cart drawer still runs. */
    barButton.addEventListener('click', function () {
      var realButton = form.querySelector('.product-form__submit');
      if (realButton && !realButton.disabled) realButton.click();
    });

    function sync() {
      var realButton = form.querySelector('.product-form__submit');
      var media = root.querySelector('.product__media img');

      if (realButton) {
        barButton.disabled = realButton.disabled;
        var label = realButton.querySelector('span');
        barButton.textContent =
          realButton.disabled && label ? label.textContent.trim() : barButton.dataset.addLabel;
      }

      priceEl.textContent = priceText(root);

      var chosen = [];
      root.querySelectorAll('.product-form__input input[type="radio"]:checked').forEach(function (input) {
        if (input.value) chosen.push(input.value.trim());
      });
      titleEl.textContent = chosen.length
        ? titleEl.dataset.baseTitle + ' · ' + chosen.join(' / ')
        : titleEl.dataset.baseTitle;

      if (mediaEl && media) mediaEl.src = media.currentSrc || media.src;
    }

    sync();

    /* Dawn re-renders the buy box after a variant change. */
    root.addEventListener('change', function () {
      window.setTimeout(sync, 400);
    });
    document.addEventListener('variant:change', function () {
      window.setTimeout(sync, 60);
    });
  }

  function boot() {
    document.querySelectorAll('.premium-product').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
